/**
 * Delte komponenter for leverandørkontoer: kontaktstatus og redigering.
 */
import { useState, type FormEvent } from 'react';
import { api, type VendorAccount } from '../lib/api.ts';
import { Field, inputKlasse, knappPrimær, knappSekundær, Modal } from './ui.tsx';

export function KontoStatus({ status, feil }: { status: string; feil: string | null }) {
  if (status === 'ok') return <span className="font-medium text-green-700">✓ Kontakt OK</span>;
  if (status === 'feil')
    return (
      <span className="font-medium text-red-600" title={feil ?? ''}>
        ✗ Ikke kontakt
      </span>
    );
  return <span className="text-slate-500">Venter på synk</span>;
}

export function KontoRedigerModal({
  konto,
  tenantQuery,
  onClose,
}: {
  konto: VendorAccount;
  tenantQuery?: string;
  onClose: () => void;
}) {
  const [feil, setFeil] = useState<string | null>(null);
  const [jobber, setJobber] = useState(false);

  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setJobber(true);
    setFeil(null);
    const fd = new FormData(e.currentTarget);
    const body: Record<string, unknown> = { navn: fd.get('navn') };
    const username = fd.get('username') as string;
    const password = fd.get('password') as string;
    if (username && username !== konto.username) body.username = username;
    if (password) body.password = password;
    try {
      await api.patch(`/vendor-accounts/${konto.id}${tenantQuery ? `?${tenantQuery}` : ''}`, body);
      onClose();
    } catch (err) {
      setFeil(err instanceof Error ? err.message : 'Feil');
    } finally {
      setJobber(false);
    }
  }

  return (
    <Modal tittel={`Rediger ${konto.vendor}-konto`} onClose={onClose}>
      <form onSubmit={submit} className="space-y-3">
        <Field label="Visningsnavn">
          <input name="navn" required defaultValue={konto.navn} className={inputKlasse} />
        </Field>
        <Field label="Zaptec Portal-brukernavn (e-post)">
          <input name="username" type="email" defaultValue={konto.username ?? ''} className={inputKlasse} />
        </Field>
        <Field label="Nytt passord (tomt = uendret)">
          <input name="password" type="password" className={inputKlasse} />
        </Field>
        <p className="text-xs text-slate-400">
          Endres brukernavn eller passord, valideres innloggingen mot leverandøren før lagring, og en
          ny synk startes automatisk.
        </p>
        {feil && <p className="text-sm text-red-600">{feil}</p>}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose} className={knappSekundær}>
            Avbryt
          </button>
          <button type="submit" disabled={jobber} className={knappPrimær}>
            {jobber ? 'Validerer …' : 'Lagre'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
